/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";
import Serializer from "App/model/serializer";
import IScene from "js_interface/src/scene_interface";

export
class LightingSettingsData {

    public advancedLighting: false;
    public headLightIntensity: number;
    public ambientLightIntensity: number;
    public sunLightIntensity: number;
    public sunLightOrientation: number;
    public sunLightElevation: number;
    public ambientEqualsDiffuse: number;
}

export default
class LightingSettings {

    public data: LightingSettingsData = new LightingSettingsData();
    private _sceneAPI: IScene;
    private _modelDescription: Description;

    constructor(aModelDescription: Description, aSceneAPI: IScene) {
        this._modelDescription = aModelDescription;
        this._sceneAPI = aSceneAPI;
    }

    public parse(aModelDescriptionJSON: any): boolean {
        // use default lighting in case that the lighting is not defined in the model description
        if (!aModelDescriptionJSON.hasOwnProperty("ModelLightingSettings")) {
            if (this._sceneAPI.checkModulesInitialized()) {
                this._sceneAPI.lightingModule.setDefaultLighting();
                this._sceneAPI.lightingModule.enableHeadLight(this._sceneAPI.lightingModule.getHeadLightEnabled());
                this._sceneAPI.lightingModule.enableSunLight(this._sceneAPI.lightingModule.getSunLightEnabled());
            }
            return;
        }

        if (this._sceneAPI.checkModulesInitialized()) {
            // enable both lights as we do not have defined which one is enabled and which one is not
            this._sceneAPI.lightingModule.enableHeadLight(true);
            this._sceneAPI.lightingModule.enableSunLight(true);

            // Todo tb: check if this is needed - should be done via parsefrommodeldescription
            if (aModelDescriptionJSON.ModelLightingSettings.headLightIntensity !== undefined) {
                this._sceneAPI.lightingModule.setHeadLightIntensity(aModelDescriptionJSON.ModelLightingSettings.headLightIntensity);
                this.data.headLightIntensity = aModelDescriptionJSON.ModelLightingSettings.headLightIntensity;
            }

            if (aModelDescriptionJSON.ModelLightingSettings.ambientLightIntensity !== undefined) {
                this._sceneAPI.lightingModule.setAmbientLightIntensity(aModelDescriptionJSON.ModelLightingSettings.ambientLightIntensity);
                this.data.ambientLightIntensity = aModelDescriptionJSON.ModelLightingSettings.ambientLightIntensity;
            }

            if (aModelDescriptionJSON.ModelLightingSettings.sunLightIntensity !== undefined) {
                this._sceneAPI.lightingModule.setSunLightIntensity(aModelDescriptionJSON.ModelLightingSettings.sunLightIntensity);
                this.data.sunLightIntensity = aModelDescriptionJSON.ModelLightingSettings.sunLightIntensity;
            }

            if (aModelDescriptionJSON.ModelLightingSettings.sunLightOrientation !== undefined) {
                this._sceneAPI.lightingModule.setSunLightOrientation(aModelDescriptionJSON.ModelLightingSettings.sunLightOrientation);
                this.data.sunLightOrientation = aModelDescriptionJSON.ModelLightingSettings.sunLightOrientation;
            }

            if (aModelDescriptionJSON.ModelLightingSettings.sunLightElevation !== undefined) {
                this._sceneAPI.lightingModule.setSunLightElevation(aModelDescriptionJSON.ModelLightingSettings.sunLightElevation);
                this.data.sunLightElevation = aModelDescriptionJSON.ModelLightingSettings.sunLightElevation;
            }

            if (aModelDescriptionJSON.ModelLightingSettings.ambientEqualsDiffuse !== undefined) {
                this._sceneAPI.lightingModule.setAmbientEqualsDiffuse(aModelDescriptionJSON.ModelLightingSettings.ambientEqualsDiffuse);
                this.data.ambientEqualsDiffuse = aModelDescriptionJSON.ModelLightingSettings.ambientEqualsDiffuse;
            }
        }

        if (aModelDescriptionJSON.ModelLightingSettings.advancedLighting !== undefined) {
            this.data.advancedLighting = aModelDescriptionJSON.ModelLightingSettings.advancedLighting;
        }

        return true;
    }

    public getProperties(): LightingSettingsData {
        return Serializer.deepClone(this.data);
    }

    public getJSONRepresentation() {
        return this.getProperties();
    }
}
